import React from 'react';
import { useCart } from '../context/CartContext';
import '../styles/Cart.css';

const Cart = () => {
  const {
    cartItems,
    isCartOpen,
    cartNote,
    setCartNote,
    removeFromCart,
    incrementQuantity,
    decrementQuantity,
    getTotalItems,
    getTotalPrice,
    closeCart,
    sendToWhatsApp,
    payWithMercadoPago,
    clearCart,
  } = useCart();

  if (!isCartOpen) return null;

  const handleConfirmOrder = () => {
    if (cartItems.length === 0) {
      alert('El carrito está vacío');
      return;
    }
    
    sendToWhatsApp();
    // Opcional: limpiar carrito después de enviar
    // clearCart();
    // closeCart();
  };

  return (
    <>
      {/* Overlay oscuro */}
      <div className="cart-overlay" onClick={closeCart}></div>
      
      {/* Panel lateral del carrito */}
      <div className="cart-panel">
        {/* Header del carrito */}
        <div className="cart-header">
          <h2 className="cart-title">
            🛒 Mi Carrito
            {getTotalItems() > 0 && (
              <span className="cart-count-badge">{getTotalItems()}</span>
            )}
          </h2>
          <button className="cart-close-btn" onClick={closeCart} aria-label="Cerrar carrito">
            ✕
          </button>
        </div>

        {/* Contenido del carrito */}
        <div className="cart-content">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <div className="cart-empty-icon">🛒</div>
              <p className="cart-empty-text">Tu carrito está vacío</p>
              <button className="btn btn-primary" onClick={closeCart}>
                Ir a comprar
              </button>
            </div>
          ) : (
            <>
              {/* Lista de productos */}
              <div className="cart-items">
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-item-wrapper">
                    {/* Título del producto */}
                    <h3 className="cart-item-name">{item.descripcion}</h3>
                    
                    {/* Contenedor del producto */}
                    <div className="cart-item">
                      {/* Imagen del producto */}
                      <div className="cart-item-image">
                        {item.imagenes && item.imagenes.length > 0 ? (
                          <img 
                            src={item.imagenes[0]} 
                            alt={item.descripcion}
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/80x80?text=Sin+Imagen';
                            }}
                          />
                        ) : (
                          <div className="cart-item-placeholder">📦</div>
                        )}
                      </div>

                      {/* Info del producto */}
                      <div className="cart-item-info">
                        <p className="cart-item-price">${item.precio.toLocaleString()}</p>
                        
                        {/* Controles de cantidad */}
                        <div className="cart-item-quantity">
                          <button 
                            className="quantity-btn" 
                            onClick={() => decrementQuantity(item.id)}
                            aria-label="Disminuir cantidad"
                          >
                            −
                          </button>
                          <span className="quantity-value">{item.quantity}</span>
                          <button 
                            className="quantity-btn" 
                            onClick={() => incrementQuantity(item.id)}
                            aria-label="Aumentar cantidad"
                          >
                            +
                          </button>
                        </div>

                        {/* Subtotal */}
                        <p className="cart-item-subtotal">
                          Subtotal: <strong>${(item.precio * item.quantity).toLocaleString()}</strong>
                        </p>
                      </div>

                      {/* Botón eliminar */}
                      <button 
                        className="cart-item-remove" 
                        onClick={() => removeFromCart(item.id)}
                        aria-label="Eliminar producto"
                        title="Eliminar del carrito"
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Nota adicional */}
              <div className="cart-note-section">
                <label htmlFor="cart-note" className="cart-note-label">
                  📝 Agregar nota al pedido (opcional)
                </label>
                <textarea
                  id="cart-note"
                  className="cart-note-textarea"
                  placeholder="Ej: Entrega entre 9-12hs, sin timbre, etc..."
                  value={cartNote}
                  onChange={(e) => setCartNote(e.target.value)}
                  rows="3"
                />
              </div>
            </>
          )}
        </div>

        {/* Footer del carrito (solo si hay productos) */}
        {cartItems.length > 0 && (
          <div className="cart-footer">
            {/* Resumen */}
            <div className="cart-summary">
              <div className="cart-summary-row">
                <span>Items:</span>
                <span>{getTotalItems()}</span>
              </div>
              <div className="cart-summary-row cart-total">
                <span>Total:</span>
                <span className="cart-total-price">${getTotalPrice().toLocaleString()}</span>
              </div>
            </div>

            {/* Botones de acción */}
            <button 
              className="btn btn-primary btn-large cart-pay-btn"
              onClick={payWithMercadoPago}
            >
              <span>💳</span>
              Pagar con MercadoPago
            </button>

            <button 
              className="btn btn-whatsapp btn-large cart-confirm-btn"
              onClick={handleConfirmOrder}
            >
              <span>💬</span>
              Confirmar Pedido por WhatsApp
            </button>

            <button 
              className="cart-clear-btn"
              onClick={() => {
                if (window.confirm('¿Estás seguro de vaciar el carrito?')) {
                  clearCart();
                }
              }}
            >
              Vaciar carrito
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;

